(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-card-buy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('[data-cc-variant-select]')) return;
    var form = select.closest('product-form');
    if (!form) return;
    var input = form.querySelector('[name="id"]');
    var button = form.querySelector('[type="submit"]');
    var option = select.options[select.selectedIndex];
    if (!input || !button || !option) return;
    var available = option.dataset.available === 'true';
    input.value = select.value;
    input.disabled = !available;
    button.disabled = !available;
    button.querySelector('span').textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
    if (typeof form.handleErrorMessage === 'function') form.handleErrorMessage();
  });
  } catch(e) { console.error(e); }
})();

})();
